import {styled} from '@mui/system'

export const OthersDataStyled = styled('div')(({theme}) => ({
  marginBottom: theme.spacing(18),
  '.ant-form': {
    paddingBottom: theme.spacing(18),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(11)
  },
  '.container': {
    border: `1px solid ${theme.palette.neutral[100]}`,
    borderRadius: theme.spacing(1),
    '&-title': {
      padding: `${theme.spacing(5)} ${theme.spacing(6.5)}`
    },
    '&-body': {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(7.5),
      padding: `${theme.spacing(5)} ${theme.spacing(6.5)}`,
      '&-row': {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: theme.spacing(15)
      },
      '&-element': {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2.5),
        '&-icon': {
          flexDirection: 'row',
          alignItems: 'flex-end'
        }
      }
    },
    '.ant-input': {
      height: theme.spacing(19),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3)
    },
    '.ant-input[disabled]': {
      backgroundColor: '#eee',
      borderColor: '#ccc',
      color: '#555'
    },

    '.ant-picker': {
      height: theme.spacing(19),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      width: '100%',

      '&.ant-picker-disabled': {
        backgroundColor: '#eee',
        borderColor: '#ccc',
        color: '#555'
      },

      '& .ant-picker-input > input[disabled]': {
        backgroundColor: '#eee',
        borderColor: '#ccc',
        color: '#555'
      }
    },
    '.ant-form-item': {
      marginBottom: 0,
      width: '100%'
    },

    '.ant-radio-disabled + span': {
      color: '#555'
    },
    '.ant-radio-row': {
      '.ant-radio-inner': {
        borderRadius: 0,
        '&:after': {
          borderRadius: 0,
          backgroundColor: '#555'
        }
      },
      '.ant-form-item-row': {
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        alignItems: 'center',
        '.ant-form-item-label': {
          padding: 0
        }
      }
    },
    '.ant-divider': {
      margin: 0
    },
    '.ant-select': {
      width: '100%',
      minWidth: '130px',
      '.ant-select-selector': {
        height: theme.spacing(19),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        borderRadius: theme.spacing(21),

        '.ant-select-selection-placeholder': {
          lineHeight: 'unset'
        },

        '.ant-select-selection-item': {
          lineHeight: 'unset'
        },

        '.ant-select-selection-overflow': {
          position: 'absolute',
          '.ant-select-selection-item': {
            borderRadius: '16px'
          }
        }
      }
    }
  }
}))
